export function euro(cents) {
  const v = (Number(cents || 0) / 100);
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(v);
}

export function toCents(value) {
  if (value === "" || value == null) return 0;
  return Math.round(parseFloat(String(value).replace(",", ".")) * 100);
}

export function fromCents(cents) {
  return (Number(cents || 0) / 100).toString();
}

export function dt(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" });
}

export function timeOnly(iso) {
  if (!iso) return "-";
  return new Date(iso).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });
}

export const ROLE_LABELS = {
  super_admin: "Super Admin Network",
  partner_admin: "Partner Admin",
  operator: "Operatore",
};

export const PAYMENT_LABELS = { cash: "Contanti", card: "Carta/POS", stripe: "Carta online (Stripe)", other: "Altro" };

export const POOL_STATE_LABELS = {
  CLEAN_AVAILABLE: "Pulito disponibile",
  AT_CUSTOMER: "Presso clienti",
  DIRTY: "Sporco",
  IN_PROCESS: "In lavorazione",
  DAMAGED: "Danneggiato",
  DISCARDED: "Scarto",
};
